module.exports = __webpack_public_path__ + "static/media/WhatsApp11.0f46fd08.jpeg";